import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import Button from '../../../Button'
import { PROFILE_CONTACTS_WIDGET_QA_NAME } from '../ProfileContactsWidget.constants'

import * as styles from './ProfileContactsWidgetFormButtons.module.css'

function ProfileContactsWidgetFormButtons({ onCancel }) {
  const { t } = useTranslation()

  const { isSubmitting } = useFormikContext()

  return (
    <div className={styles.buttons}>
      <Button.Contained
        isLoading={isSubmitting}
        qaName={PROFILE_CONTACTS_WIDGET_QA_NAME.saveButton}
        text={t('ProfileContactsWidget.BtnSaveKey')}
        type='submit'
      />
      <Button.Outlined
        disabled={isSubmitting}
        qaName={PROFILE_CONTACTS_WIDGET_QA_NAME.cancelButton}
        text={t('ProfileContactsWidget.BtnCancelKey')}
        onClick={onCancel}
      />
    </div>
  )
}

export default ProfileContactsWidgetFormButtons
